import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleBtn", "toggleKnob", "monthlyPrice", "yearlyPrice", "monthlyLabel", "yearlyLabel"]

  toggle() {
    const isYearly = this.toggleKnobTarget.classList.contains("translate-x-6")

    if (isYearly) {
      // Switch to monthly
      this.toggleKnobTarget.classList.remove("translate-x-6")
      this.toggleKnobTarget.classList.add("translate-x-1")
      this.toggleBtnTarget.classList.remove("bg-indigo-500")
      this.toggleBtnTarget.classList.add("bg-gray-300")
      this.monthlyPriceTargets.forEach(el => el.classList.remove("hidden"))
      this.yearlyPriceTargets.forEach(el => el.classList.add("hidden"))
    } else {
      // Switch to yearly
      this.toggleKnobTarget.classList.remove("translate-x-1")
      this.toggleKnobTarget.classList.add("translate-x-6")
      this.toggleBtnTarget.classList.remove("bg-gray-300")
      this.toggleBtnTarget.classList.add("bg-indigo-500")
      this.monthlyPriceTargets.forEach(el => el.classList.add("hidden"))
      this.yearlyPriceTargets.forEach(el => el.classList.remove("hidden"))
    }
  }
}
